var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#9C1FE9",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2333_49337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8C14.4178 8 12.871 8.46919 11.5554 9.34824C10.2398 10.2273 9.21447 11.4767 8.60897 12.9385C8.00347 14.4003 7.84504 16.0089 8.15372 17.5607C8.4624 19.1126 9.22433 20.538 10.3431 21.6569C11.462 22.7757 12.8874 23.5376 14.4393 23.8463C15.9911 24.155 17.5997 23.9965 19.0615 23.391C20.5233 22.7855 21.7727 21.7602 22.6518 20.4446C23.5308 19.129 24 17.5822 24 16C24 13.8783 23.1571 11.8434 21.6569 10.3431C20.1566 8.84285 18.1217 8 16 8ZM16 23C14.6155 23 13.2622 22.5895 12.111 21.8203C10.9599 21.0511 10.0627 19.9579 9.53285 18.6788C9.00303 17.3997 8.86441 15.9922 9.13451 14.6344C9.4046 13.2765 10.0713 12.0292 11.0503 11.0503C12.0292 10.0713 13.2765 9.4046 14.6344 9.1345C15.9922 8.86441 17.3997 9.00303 18.6788 9.53284C19.9579 10.0627 21.0511 10.9599 21.8203 12.111C22.5895 13.2622 23 14.6155 23 16C23 17.8565 22.2625 19.637 20.9497 20.9497C19.637 22.2625 17.8565 23 16 23Z",
    fill: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.445 14.945C12.9973 14.945 13.445 14.4973 13.445 13.945C13.445 13.3927 12.9973 12.945 12.445 12.945C11.8927 12.945 11.445 13.3927 11.445 13.945C11.445 14.4973 11.8927 14.945 12.445 14.945Z",
    fill: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.525 14.945C20.0773 14.945 20.525 14.4973 20.525 13.945C20.525 13.3927 20.0773 12.945 19.525 12.945C18.9727 12.945 18.525 13.3927 18.525 13.945C18.525 14.4973 18.9727 14.945 19.525 14.945Z",
    fill: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.065 21.105C16.9823 21.1062 17.8763 20.8164 18.6184 20.2773C19.3605 19.7383 19.9125 18.9777 20.195 18.105H11.935C12.2175 18.9777 12.7695 19.7383 13.5116 20.2773C14.2537 20.8164 15.1477 21.1062 16.065 21.105Z",
    fill: "#9C1FE9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2333_49337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.a02228d6020c323488f0158beac256f2.svg";
export { ForwardRef as ReactComponent };